export default "__VITE_ASSET__KiUjh1y7__"